import {request} from '@weplanet-web/core'

const PATH = '/banners'

function getBanners(data: IGetBanners) {
  return request<IBanners>({url: PATH, method: 'GET', params: data})
}

export {getBanners}
